export default __webpack_public_path__ + "static/media/gallery_07.43349f0a.jpg";